export default {"allianceTagContainer":"-J-vk","hasProducts":"QjfHC","text":"_82nA0","zoomOutMobile":"K0OwN"};